import type { Look } from './types';

/**
 * The looks a battle, the global setting or a preview can name, in the order the switcher shows them: Bold (the default
 * since 8 Oct 2026: the clinical identity at full volume), Clinical (code value 'ward'), Playful Theatre (9 Oct 2026:
 * Bold without the dot grid, with the podium and the share card staged as a moment) and MedSnapp (3 Nov 2026: MedSnapp's
 * own colours with its organ cast in the moments). One list for the web app and the
 * API, so a look the server refuses is a look the app does not know either.
 */
export const LOOKS: readonly Look[] = ['bold', 'ward', 'playful', 'theatre', 'medsnapp'];
/** The look a battle, a page or the global setting shows when nothing says otherwise. */
export const DEFAULT_LOOK: Look = 'bold';
export const isLook = (v: unknown): v is Look => typeof v === 'string' && (LOOKS as readonly string[]).includes(v);
